import React from 'react'

interface Props {
  title: string
  children: React.ReactNode
}

const FormHeader: React.FunctionComponent<Props> = ({ title, children }) => {
  return (
    <div className="gap-12 md:grid md:grid-cols-5 mb-24">
      <div className="md:col-span-3">
        <h1 className="font-ttHovesBold text-3xl mb-4 lg:mt-6 lg:text-4xl">
          {title}
        </h1>
        <div id="markdown-content">{children}</div>
      </div>
      <div className="col-span-2 bg-gray-stripes bg-no-repeat bg-cover hidden h-32 -mr-11 md:block lg:h-64" />
    </div>
  )
}

export default FormHeader
